import { FC, ReactNode, createContext, useContext } from 'react';

interface GoogleReCaptchaV2ProviderProps {
	reCaptchaKey: string;
	children: ReactNode;
}

export const ReCaptchaV2Context = createContext<string>('');

const GoogleReCaptchaV2Provider: FC<GoogleReCaptchaV2ProviderProps> = ({ reCaptchaKey, children }) => {
	if (!reCaptchaKey) {
		return null;
	}

	return <ReCaptchaV2Context.Provider value={reCaptchaKey}>{children}</ReCaptchaV2Context.Provider>;
};

export const useReCaptchaV2 = () => {
	const reCaptchaV2SiteKey = useContext(ReCaptchaV2Context);
	return { reCaptchaV2SiteKey };
};

export default GoogleReCaptchaV2Provider;
